"use client";

import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from "react";
import { useState } from "react";
import { getGoogleAuthUrl, getGoogleConnectUrl } from "@/lib/auth-api";

interface GoogleConnectLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  busyLabel?: ReactNode;
}

export default function GoogleConnectLink({
  children,
  busyLabel = "Connecting...",
  onClick,
  ...props
}: GoogleConnectLinkProps) {
  const [busy, setBusy] = useState(false);

  const handleClick = async (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;

    event.preventDefault();
    if (busy) return;

    setBusy(true);
    try {
      window.location.href = await getGoogleConnectUrl();
    } catch {
      window.location.href = "/sign-in";
    }
  };

  return (
    <a
      {...props}
      href={props.href ?? getGoogleAuthUrl()}
      aria-busy={busy}
      onClick={handleClick}
    >
      {busy ? busyLabel : children}
    </a>
  );
}
